export default __webpack_public_path__ + "static/media/mobile1.ff728617.png";